module.exports = __webpack_public_path__ + "media/images/flags/1x1/swz-346ef0b3c88a7eddf67d76607e420e8f.svg";